import { useState } from "react";
import { useLocation } from "react-router-dom";
import SidebarNavigation from "./SidebarNavigation";

interface AppLayoutProps {
  children: React.ReactNode;
}

function AppLayout({ children }: AppLayoutProps): JSX.Element {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  // Don't show sidebar on login/register pages and share routes
  const noSidebarRoutes = ["/login", "/register"];
  const isShareRoute = location.pathname.startsWith("/share/");
  const showSidebar = !noSidebarRoutes.includes(location.pathname) && !isShareRoute;

  return (
    <div className={`app-layout ${!showSidebar ? "app-layout--no-sidebar" : ""}`}>
      {showSidebar && (
        <>
          <SidebarNavigation isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />
          <button
            type="button"
            className="mobile-menu-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-label="Toggle menu"
          >
            {sidebarOpen ? "✕" : "☰"}
          </button>
        </>
      )}
      <div style={{ minWidth: 0, minHeight: "100vh" }}>{children}</div>
    </div>
  );
}

export default AppLayout;
